import React, { Component } from "react";
import { Link } from 'react-router-dom'

export default class Forydeb extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      strengths : []
    };
  }

  componentDidMount() {}

  render() {

    const fortalezas = this.props.fortalezas.map((f,fi) => {
      return <tr>
                {/* <td key={"fortalezas-" + fi}>{ f }</td> */}
                {/* <td key={"debilidades-" + fi}>{ this.props.debilidades[fi] }</td> */}
                <td key={"fortalezas-" + fi} dangerouslySetInnerHTML={{__html: f}}></td>
                <td key={"debilidades-" + fi} dangerouslySetInnerHTML={{__html: this.props.debilidades[fi]}}></td>
              </tr>

    })

    return (
      <div className="padding-0">
        <table className="table table-striped">
          <thead>
            <tr>
              <th scope="col" className="upper b-bottom-g"><i className="far fa-smile"></i> Fortalezas</th>
              <th scope="col" className="upper b-bottom-r"><i className="far fa-frown"></i> Debilidades</th>
            </tr>
          </thead>
          <tbody>
            
              { fortalezas }
            
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/types/Forydeb.jsx